import { Loader2, Send } from "lucide-react";
import type { UseFormRegister } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { DocumentosLabels } from "@/lib/labels/documentos";
import type { SignaturePreparationForm } from "@/routes/_app/pessoa/-utils/signature-preparation";

export function SendTermsFooter({
	documents,
	filledFields,
	totalFields,
	isPending,
	canSubmit,
	register,
	onClose,
}: {
	documents: number;
	filledFields: number;
	totalFields: number;
	isPending: boolean;
	canSubmit: boolean;
	register: UseFormRegister<SignaturePreparationForm>;
	onClose: () => void;
}) {
	return (
		<footer className="flex flex-col gap-3 border-t border-border bg-card px-5 py-4 lg:flex-row lg:items-center lg:justify-between">
			<div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
				<span>{DocumentosLabels.preparation.documentCount(documents)}</span>
				<span>{DocumentosLabels.preparation.fieldProgress(filledFields, totalFields)}</span>
			</div>

			<div className="flex flex-wrap items-end justify-end gap-3">
				<label className="flex flex-col gap-1">
					<span className="text-xs font-medium text-muted-foreground">
						{DocumentosLabels.sendDeadline}
					</span>

					<span className="flex items-center gap-2">
						<input
							type="number"
							min={1}
							max={365}
							disabled={isPending}
							className="control-field h-11 w-20 md:h-10"
							{...register("deadlineDays", { valueAsNumber: true })}
						/>
						<span className="text-xs text-muted-foreground">
							{DocumentosLabels.preparation.deadlineSuffix}
						</span>
					</span>
				</label>

				<Button type="button" variant="secondary" size="sm" disabled={isPending} onClick={onClose}>
					Cancelar
				</Button>

				<Button
					type="submit"
					data-slot="send-submit"
					variant="default"
					size="sm"
					className="px-4"
					disabled={!canSubmit}
				>
					{isPending && <Loader2 className="animate-spin" />}
					{!isPending && <Send />}
					{isPending && DocumentosLabels.sending}
					{!isPending && DocumentosLabels.sendConfirm}
				</Button>
			</div>
		</footer>
	);
}
